/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import kogic from "../../images_logos/kogic_logo.svg"
import ulsan from "../../images_logos/ulsan_logo.svg"

import { BsFillCalendarCheckFill, BsFillAlarmFill} from "react-icons/bs";
import { ImLocation} from "react-icons/im";


const RegistrationBooth = () => {
    return(
        <div className="sect-01-box-01-visitor">
            <div className="sect-tit">{t("vis_guide_info_title")}</div>
            <div className='tbl-visitor-guide-info'>
                <table>
                    <colgroup>
                        <col width="30%"/>
                        <col width="5%"/>
                        <col width="30%"/>
                        <col width="5%"/>
                        <col width="30%"/>
                    </colgroup>
                    <tr>
                        <td>
                            <div className='visitor-guide-info-cont-box'>
                                <div className='visitor-guide-info-cont-wrap'>
                                    <div className='visitor-guide-info-cont'>
                                        <div className='visitor-guide-info-cont-icon'>
                                            <BsFillCalendarCheckFill size={30} color="#AC2371"/>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_calendar_cont1")}
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_calendar_cont2")}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td></td>
                        <td>
                            <div className='visitor-guide-info-cont-box'>
                                <div className='visitor-guide-info-cont-wrap'>
                                    <div className='visitor-guide-info-cont'>
                                        <div className='visitor-guide-info-cont-icon'>
                                            <BsFillAlarmFill size={30} color="#AC2371"/>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_time_cont1")}
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_time_cont2")}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td></td>
                        <td>
                            <div className='visitor-guide-info-cont-box'>
                                <div className='visitor-guide-info-cont-wrap'>
                                    <div className='visitor-guide-info-cont'>
                                        <div className='visitor-guide-info-cont-icon'>
                                            <ImLocation size={30} color="#AC2371"/>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_place_cont1")}
                                    </div>
                                    <br/>
                                    <div className='visitor-guide-info-cont'>
                                        {t("vis_guide_info_place_cont2")}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    )
}

export default RegistrationBooth;